import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField } from "../../../../../../../../../api/types/svTypes.ts";
import CustomLabel from "../../../../viewer/common/fields/CustomLabel.tsx";
import FieldOptionDeleteButton from "../../../../viewer/common/fields/FieldOptionDeleteButton.tsx";
import FieldOptionsDivider from "../../../../viewer/common/fields/FieldOptionsDivider.tsx";
import DimensionAggregation from "../../../common/fields/dimension-aggregation/DimensionAggregation";
import useDimensionFieldOptions from "../../../common/fields/dimensions/hooks/useDimensionFieldOptions";
import BlankZeroMenuItem from "../../../common/fields/field-options/BlankZeroMenuItem.tsx";
import ReverseSignMenuItem from "../../../common/fields/field-options/ReverseSignMenuItem.tsx";

interface Props {
  field: DimensionField;
  cancel: () => void;
  onRemove: () => void;
  onUpdateConfiguration: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  onUpdateCustomLabel: (name: string | undefined) => void;
  readonly: boolean;
}

export default function DimensionFieldOptions({
  field,
  cancel,
  onRemove,
  onUpdateConfiguration,
  onUpdateCustomLabel,
  readonly,
}: Props) {
  const { handleRemove, saveChanges, onUpdateAggregation } = useDimensionFieldOptions({
    field,
    cancel,
    onRemove,
    onUpdateConfiguration,
  });

  return (
    <>
      <CustomLabel
        customFieldValue={field.config.customLabel}
        originalFieldValue={field.meta.caption}
        updateCustomFieldValue={onUpdateCustomLabel}
        readonly={readonly}
      />
      <FieldOptionsDivider />
      <DimensionAggregation
        field={field}
        onChange={onUpdateAggregation}
        hideAggregationType={!!field.config.persistedAggregationName}
        readonly={readonly}
      />
      <BlankZeroMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
      <ReverseSignMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
      <FieldOptionsDivider />
      {!readonly && <FieldOptionDeleteButton onRemove={handleRemove} />}
    </>
  );
}
